import { apiService } from "../../../../services/api/apiService";
import { ClientGeneralParams } from "../types";

const BASE_URL = "/client";

export const getGeneralParams = async (): Promise<ClientGeneralParams> => 
    await apiService.get<ClientGeneralParams>(`${BASE_URL}/parameters`);

export const updateGeneralParams = async (body: ClientGeneralParams): Promise<void> => {
    const formData = new FormData();

    if (body.logoFile) {
        formData.append("logoFile", body.logoFile);
    }

    Object.entries(body).forEach(([key, value]) => {
        if (key !== "logoFile" && value !== undefined && value !== null) {
            formData.append(key, value.toString());
        }
    });
    await apiService.post<FormData, void>(`${BASE_URL}/parameters`, formData);
}